module.exports = __webpack_public_path__ + "c09622bd2ac7046a0f699e7225018d2d.png";